import React, { useEffect, useState } from "react";
import SignUpForm from "../../components/organisms/SignUpForm";
import SignUpTemplates from "../../components/template/SignUpTemplates";
import { SubmitHandler, useForm } from "react-hook-form";
import { schema } from "./sign-up-schema";
import { yupResolver } from "@hookform/resolvers/yup";
import { SignUpType } from "../../types/signup.types";
import { userSignState } from "../../states/user-sign-up";
import { useRecoilState } from "recoil";
import { useMutation } from "@tanstack/react-query";
import { request } from "../../lib/api";
import { GET_USER_ID_CHECK } from "../../common/query-keys";
import { useNavigate } from "react-router";
import { CmpTemplates } from "../../components/template/CmpTemplates";

const SignUpPage = (props: any) => {
  const navigate = useNavigate();

  const [userSignUpData, setUserSignUpData] = useRecoilState(userSignState);
  const [isButtonTrue, setIsButtonTrue] = useState<boolean>(false);

  const {
    register,
    setValue,
    handleSubmit,
    reset,
    watch,
    formState: { errors },
  } = useForm<any>({
    resolver: yupResolver(schema),
  });

  useEffect(() => {
    reset(userSignUpData.userInfo);
  }, [userSignUpData.userInfo]);

  useEffect(() => {
    const isTrue = Object.values(watch()).some(
      (value) => typeof value === "string" && value.trim() !== ""
    );

    setIsButtonTrue(isTrue);
  }, [watch()]);

  const { mutateAsync: userIdCheckFunc } = useMutation({
    mutationFn: (data: { userId: string }) => {
      return request({
        method: "POST",
        url: GET_USER_ID_CHECK,
        data: data,
      });
    },
    onSuccess: (res: any) => {
      if (res.success) {
        navigate("/cmp-car-page");
      } else {
        alert(res.message);
      }
    },
  });

  /** 다음 버튼 클릭시 */
  const onSubmit: SubmitHandler<SignUpType> = async (data: SignUpType) => {
    setUserSignUpData((prev: any) => ({
      ...prev,
      userInfo: {
        ...prev.userInfo,
        userId: data.userId,
        username: data.username,
        password: data.password,
        userPwCheck: data.userPwCheck,
        email: data.email,
        phoneNumber: data.phoneNumber,
      },
    }));

    await userIdCheckFunc({ userId: data.userId });
  };

  /** 이전 버튼 클릭시 */
  const onBackPageClickHandler = () => {
    navigate(-1);
  };

  return (
    <CmpTemplates pageTitle="회원가입">
      <SignUpForm
        onSubmit={onSubmit}
        register={register}
        setValue={setValue}
        errors={errors}
        handleSubmit={handleSubmit}
        isButtonTrue={isButtonTrue}
        onBackPageClickHandler={onBackPageClickHandler}
      />
    </CmpTemplates>
  );
};

export default SignUpPage;
